<template>
  <section class="iv-public-sentiment-todo iv-main-width">
    <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-t-40 iv-m-b-16">舆情发生组织领导审核</h1>
    <article class="iv-public-sentiment-todo-content">
      <!-- 基础信息 -->
      <FormLayout
        ref="baseConfig" 
        :readOnly="true"
        :model="publicInfo"
        :list="baseConfig">
      </FormLayout>
      <LayoutTitle title="处理信息">
        <FormLayout
          ref="attachmentInfo"
          :model="publicInfo.publicOpinionProcess"
          :list="handleConfig">
        </FormLayout>
      </LayoutTitle>
      <!-- 审核结果 -->
      <LayoutTitle class="iv-m-b-36" title="审核结果">
        <FormLayout
          ref="examineForm"
          :readOnly="isView"
          :model="examineInfo"
          :list="examineResultConfig">
        </FormLayout>
        <DragTable
          noSearch
          ref="DragTable"
          class="iv-m-t-12"
          :showEdit="false"
          :showDelete="false"
          :showSelect="false"
          :showPage="false"
          :columns="resultTableConfig" 
          :tableData="publicInfo.approveLogs">
        </DragTable>
      </LayoutTitle>
    </article>
    <FooterOperator>
      <Button v-if="!isView" class="iv-m-r-8" type="submit" :disabled="disabled" @click="submitHandledResult">提交审核</Button>
      <Button type="close" @click="back">关闭</Button>
    </FooterOperator>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </section>
</template>

<script>
import { timeFormat } from '@/utils'
import FormLayout from '@/components/layout/form'
import FooterOperator from '@/components/footer-operator'
import LayoutTitle from '@/components/layout/layout-title'
import DragTable from '@/components/drag-table-inline'
import { baseConfig, handleConfig, examineResultConfig, resultTableConfig } from './form-config.js'

export default {
  data () {
    return {
      publicInfo: {},
      dictMap: {},
      baseConfig: [],
      handleConfig: [],
      examineResultConfig: [],
      resultTableConfig: [],
      spinShow: false,
      examineInfo: {},
      disabled: false
    }
  },
  async created () {
    this.processId = this.$route.query.processId
    this.publicOpinionId = this.$route.query.publicOpinionId
    this.isView = this.$route.query.view == 'see'
    this.spinShow = true
    this.getCodeTable('BOE62')
    this.getCodeTable('KZ41')
    this.getPostBarConfig()
    await this.getCodeTable('BOE82')
    await this.getCodeTable('BOE48')
    await this.getPublicSentimentDetail()
    this.baseConfig = baseConfig.call(this)
    this.handleConfig = handleConfig.call(this)
    this.examineResultConfig = examineResultConfig.call(this)
    this.resultTableConfig = resultTableConfig.call(this)
    this.spinShow = false
  },
  mounted () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.$set(this.examineInfo, 'auditUserName', sessionStorage.getItem('userName'))
      this.$set(this.examineInfo, 'auditUserId', sessionStorage.getItem('userId'))
      this.$set(this.examineInfo, 'auditOrgName', sessionStorage.getItem('politicsOrgName')) //用户的行政机构名称
      this.$set(this.examineInfo, 'auditOrgId', '')
      this.$set(this.examineInfo, 'isShare', '0')
      this.$set(this.examineInfo, 'auditTime', new Date())
    },
    //获取详情
    getPublicSentimentDetail () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/module/publicOpinionProcess/get',
          method: 'get',
          data: {
            processId: this.processId
          }
        }).then(async ({data}) => {
          this.publicInfo = data.data || {}
          this.publicInfo.postDate = new Date(this.publicInfo.postDate)
          this.publicInfo.createDate = new Date(this.publicInfo.createDate)
          this.publicInfo.discoverTime = new Date(this.publicInfo.discoverTime)
          this.publicInfo.publicOpinionOrgIds = this.publicInfo.publicOpinionOrg
          this.publicInfo.opinionLevels = this.publicInfo.opinionLevels[0] || ''
          this.publicInfo.publicOpinionType = this.publicInfo.publicOpinionType ? this.publicInfo.publicOpinionType.split(',') : []
          if (this.publicInfo.publicOpinionFileId) {
            this.getActivityFiles(this.publicInfo.publicOpinionFileId, this.publicInfo, 'uploadFile')
          }
          //处理信息
          if (this.publicInfo.publicOpinionProcess) {
            this.publicInfo.publicOpinionProcess.createDate = new Date(this.publicInfo.publicOpinionProcess.createDate)
            if (this.publicInfo.publicOpinionProcess.processFileId) {
              this.getActivityFiles(this.publicInfo.publicOpinionProcess.processFileId, this.publicInfo.publicOpinionProcess, 'handleUploadFile')
            }
          }
          //查看
          if (this.isView) {
            this.examineInfo = this.publicInfo.publicOpinionProcess
            this.examineInfo.processState += ''
            this.examineInfo.auditTime = new Date(this.examineInfo.auditTime)
            this.examineInfo.auditUserName = this.examineInfo.auditUserName || this.examineInfo.userName
          }
          resolve()
        })
      })
    },
    //提交
    submitHandledResult () {
      this.$refs.examineForm.validate((valid) => {
        if (!valid) {
          return this.$Message.error('校验未通过')
        }
        this.$ajax({
          url: '/api-uum/module/publicOpinionProcess/auditProcess',
          method: 'PUT',
          data: {
            orgId: this.examineInfo.auditOrgId,
            orgName: this.examineInfo.auditOrgName,
            auditOrgId: this.examineInfo.auditOrgId,
            auditOrgName: this.examineInfo.auditOrgName,
            auditContent: this.examineInfo.auditContent,
            processId: this.processId,
            publicOpinionId: this.publicOpinionId,
            auditUserName: this.examineInfo.auditUserName,
            auditUserId: this.examineInfo.auditUserId,
            auditTime: timeFormat(this.examineInfo.auditTime),
            processState: this.examineInfo.processState,
            isShare: this.examineInfo.isShare
          }
        }).then(({data}) => {
          this.$Message.success('提交成功')
          this.disabled = true
          this.back()
        })
      })
    },
    //返回
    back () {
      window.close()
    },
    //获取附件id 第一次上传附件 本地生产uuid
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    //获取文件信息
    getActivityFiles (groupId, obj, key) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          this.$set(obj, key, data.data || [])
          resolve()
        })
      })
    },
    //获取现地贴吧配置
    getPostBarConfig () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/module/postBarMapping/listAvailablePostBar',
          method: 'get',
          data: {
            orgId: ''
          }
        }).then(({data}) => {
          this.dictMap['postBar'] = data.data.map(item => ({
            label: item.postBarName,
            value: item.postBarId,
            ...item
          }))
          resolve()
        })
      })
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, [])
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: 'YWX05'
          }
        }).then(({data}) => {
          this.dictMap[code] = data.data.map(item => ({
            label: item.title,
            value: item.value
          }))
          resolve()
        })
      })
    }
  },
  components: {
    FormLayout,
    LayoutTitle,
    DragTable,
    FooterOperator
  }
}
</script>

<style scoped lang="scss">
.iv-public-sentiment-todo {
  background: #fff;
  padding: 16px;
}
</style>